// src/components/ModeDropdown.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMode } from "../contexts/ModeContext";

const MODES = [
  { value: "webSurrogate", label: "WebSurrogate" },
  // { value: "legacy", label: "Legacy" },
  { value: "acris-legacy", label: "ACRIS Legacy" },
  { value: "violations-v2", label: "Violation" },
];

export default function ModeDropdown({ className = "" }) {
  const { mode, setMode, loading } = useMode();
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    const next = e.target.value;
    if (!next || next === mode) return;
    if (setMode) setMode(next);

    const target =
      next === "legacy"
        ? "/legacy/dashboard"
        : next === "acris-legacy"
          ? "/acris-legacy/dashboard"
        : next === "violations-v2"
          ? "/violations-v2/dashboard"
          : "/websurrogate/dashboard";

    if (location.pathname !== target) {
      navigate(target, { replace: true });
    }
  };

  return (
    <select
      value={mode}
      onChange={handleChange}
      disabled={loading}
      className={
        "inline-flex items-center h-8 px-2.5 rounded-lg border border-[var(--border)] " +
        "bg-[var(--surface)] text-[var(--fg)] text-[11px] font-semibold " +
        (className || "")
      }
      title="Switch mode"
    >
      {MODES.map((m) => (
        <option key={m.value} value={m.value}>
          {m.label}
        </option>
      ))}
    </select>
  );
}
